import api from '@/api/base'

export default {
    login(pin) {
        return api().patch(`/kiosk/${pin}`);
    }
}